/**
 * Retrieves the summarized list of privacy policy changes
 * that the signed-in user has not yet consented on
 * */
export const retrievePrivacyPoliciesMissingConsent = () => fetch(
  '/api/v1/users/me/privacy',
  { credentials: 'same-origin' },
).then((res) => (res.status !== 204 ? res.json() : []))
  .then((data) => data.changes || []);

/**
 * Increments what the last consented privacy policy change is,
 * for the signed in user
 * */
export const acceptPrivacyPolicyChanges = () => fetch(
  '/api/v1/users/me/privacy',
  { method: 'PUT', credentials: 'same-origin' },
).then((res) => res.json());
